var DEFAULT_NAMESPACE = "platform.home.defaults";
var DEFAULT_ROUTES = {
  api: "/api/platform.home.defaults",
  page: "/dashboard/platform.home.defaults"
};

function normalizeText(value) {
  return (value || "").toString().trim();
}

function getCurrentPage(context) {
  return (((context || {}).dashboard || {}).currentPage) || ((context || {}).page) || {};
}

function getRoutes(context) {
  var currentPage = getCurrentPage(context);
  var routes = currentPage.routes || {};

  return {
    api: normalizeText(routes.api) || DEFAULT_ROUTES.api,
    page: normalizeText(routes.page) || DEFAULT_ROUTES.page
  };
}

function getCollectionRoutes(context) {
  var routes = getRoutes(context);
  var currentPage = getCurrentPage(context);
  var namespace = normalizeText(currentPage.namespace) || DEFAULT_NAMESPACE;

  return {
    namespace: namespace,
    list: {
      api: routes.api,
      page: routes.page,
      namespace: namespace
    },
    detail: {
      preview: {
        api: routes.api,
        namespace: namespace
      },
      catalog: {
        api: routes.api,
        namespace: namespace
      }
    }
  };
}

module.exports = {
  DEFAULT_NAMESPACE: DEFAULT_NAMESPACE,
  DEFAULT_ROUTES: DEFAULT_ROUTES,
  getRoutes: getRoutes,
  getCollectionRoutes: getCollectionRoutes
};
